import { motion } from "motion/react";
import { Check, TrendingUp } from "lucide-react";
import { MonthlyService } from "../../data/pricing-data";

interface MonthlyServiceCardProps {
  service: MonthlyService;
  index: number;
}

export function MonthlyServiceCard({ service, index }: MonthlyServiceCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className={`relative bg-gradient-to-br from-violet-950/40 via-fuchsia-950/40 to-cyan-950/40 rounded-3xl p-8 border ${
        service.popular ? 'border-fuchsia-400/50 ring-2 ring-fuchsia-500/30' : 'border-violet-500/20'
      } hover:border-violet-400/50 transition-all duration-300`}
    >
      {service.popular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-full text-sm font-bold">
          Most Popular
        </div>
      )}

      <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-6`}>
        <TrendingUp className="w-7 h-7 text-white" />
      </div>

      <h3 className="text-2xl font-bold mb-2 text-white">{service.name}</h3>
      <div className="flex items-baseline gap-2 mb-6">
        <span className={`text-4xl font-bold bg-gradient-to-r ${service.color} bg-clip-text text-transparent`}>
          {service.price}
        </span>
      </div>

      <ul className="space-y-3 mb-8">
        {service.features.map((feature) => (
          <li key={feature} className="flex items-start gap-2">
            <Check className="w-5 h-5 text-violet-400 flex-shrink-0 mt-0.5" />
            <span className="text-gray-300">{feature}</span>
          </li>
        ))}
      </ul>

      <a
        href="/contact"
        className={`block w-full px-6 py-3 bg-gradient-to-r ${service.color} text-white rounded-xl font-semibold text-center hover:shadow-lg hover:shadow-violet-500/50 transition-all duration-300`}
      >
        Subscribe
      </a>
    </motion.div>
  );
}